export default "__VITE_ASSET__DXA6Ttpy__"